import { StorefrontCinema } from "./storefront-cinema";
import { Cinema } from "../cinema-module/cinema";
import { getElementPositionInPageContext } from "../utils";

const root = document.getElementById("ft9_benefit_cinema__root_marker");

const featureOrder = getElementPositionInPageContext(root, "feature-order");
const cinema = new Cinema();

cinema.init(featureOrder);

const storefrontCinema = new StorefrontCinema();
storefrontCinema.init();
